import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-media-object-example',
  templateUrl: './media-object.component.html',
})
export class KitBootstrapMediaObjectExampleComponent {}
